import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
const risks = [{
  q: 'Do you have an attached garage?',
  a: "Every time you start your car, CO seeps through shared walls — even with the garage door open. It accumulates in rooms you'd never suspect."
}, {
  q: 'Is your home older than 15 years?',
  a: 'Furnace heat exchangers develop micro-cracks over time. They leak CO silently for months before anyone notices — or before your old detector ever reacts.'
}, {
  q: 'Do you use gas, propane, or oil heat?',
  a: "Any fuel-burning system produces CO. One blocked vent, one cracked pipe, one malfunction — and it's in your air supply."
}, {
  q: 'Do you have a fireplace or wood stove?',
  a: 'Creosote buildup, blocked chimneys, and downdrafts push CO back into your living space instead of up and out.'
}];
export function RiskAssessment() {
  return <section className="w-full bg-bg-alt py-5 md:py-8 px-4 sm:px-6 lg:px-8" data-id="element-332">
      <div className="max-w-[800px] mx-auto" data-id="element-333">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6" data-id="element-334">
          <span className="text-accent-orange font-medium text-[12px] tracking-wide uppercase mb-2 block" data-id="element-335">
            HOME RISK ASSESSMENT
          </span>
          <h2 className="text-[28px] md:text-[32px] font-bold text-text-primary mb-2" data-id="element-336">
            Does Your Home Have a Hidden CO Problem?
          </h2>
          <p className="text-[16px] text-text-secondary" data-id="element-337">
            Answer these four questions honestly.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2.5 mb-5" data-id="element-338">
          {risks.map((risk, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: i * 0.1
        }} className="bg-bg-card border border-border-subtle rounded-lg p-3.5 shadow-card" data-id="element-339">
              <div className="flex gap-3 mb-1.5" data-id="element-340">
                <AlertTriangle className="w-5 h-5 text-accent-orange flex-shrink-0 mt-0.5" data-id="element-341" />
                <h3 className="font-bold text-text-primary text-[16px]" data-id="element-342">
                  {risk.q}
                </h3>
              </div>
              <p className="text-text-secondary text-[14px] leading-[1.45] pl-8" data-id="element-343">
                {risk.a}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="bg-red-50 border-l-[3px] border-accent-red p-3.5 rounded-r-lg" data-id="element-344">
          <p className="text-text-primary font-bold text-[16px]" data-id="element-345">
            If you answered YES to even one of these — your home has confirmed
            CO exposure pathways right now.
          </p>
        </motion.div>
      </div>
    </section>;
}